export default __webpack_public_path__ + "static/media/decada-2000-0009-min.9728936b.jpg";